import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { makeDataForNonCollapseTable } from 'src/components/collapsible-table/table-data-prep';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useEffect } from 'react';
import { setTableMetaData } from '../../../common/features/table/store/table-slice';

export default function InnovationTable({ columns }: { columns: any }) {
  const appDispatch = useAppDispatch();

  const { tableMetadaData } = useAppSelector((state) => state.table);
  const { innovationTableMetaData } = useAppSelector(
    (state) => state.innovation
  );

  useEffect(() => {
    appDispatch(setTableMetaData({ tableData: innovationTableMetaData }));
  }, [innovationTableMetaData]);

  return (
    <CollapsibleTable
      data={makeDataForNonCollapseTable(innovationTableMetaData.row)}
      columns={columns}
      setHeightExplicitly
      extClassName='innovation-table'
    />
  );
}
